export default "__VITE_ASSET__cKR4b4YS__"